import menuStore from './MenuStore.js'
import userStore from './UserStore.js'
import usersStore from './UsersStore.js'
import projectsStore from './ProjectsStore.js'
import notificationsStore from './NotificationsStore.js'
import consultasStore from './ConsultasStore.js'
import rdiStore from './RdiStore.js'
import entregaStore from './EntregaStore.js'
import adicionalesStore from './AdicionalesStore.js'
import globalStore from './GlobalStore.js'
import generalStore from './GeneralStore.js'
import fileManagerStore from './FileManagerStore.js'
import forgeStore from './ForgeStore.js'
import meetingStore from './MeetingsStore.js'
import interactionsStore from './InteractionsStore.js'
import kanbanStore from './KanbanStore.js'

const store = {
	menuStore,
	generalStore,
	userStore,
	projectsStore,
	usersStore,
	notificationsStore,
	consultasStore,
	globalStore,
	rdiStore,
	entregaStore,
	adicionalesStore,
	fileManagerStore,
	forgeStore,
	meetingStore,
	interactionsStore,
	kanbanStore,
}

export default store